export function isPermissionGrantActive(value: unknown): boolean {
	if (value === undefined || value === null || value === false) {
		return false
	}
	if (value === true || value === 'all') {
		return true
	}
	if (Array.isArray(value)) {
		return value.length > 0
	}
	if (typeof value !== 'object') {
		return false
	}
	const obj = value as Record<string, unknown>
	if ('some' in obj) {
		const inner = obj.some
		if (Array.isArray(inner)) {
			return inner.length > 0
		}
		if (inner && typeof inner === 'object' && !Array.isArray(inner)) {
			return recordValuesGrantAccess(inner as Record<string, unknown>)
		}
		return false
	}
	return recordValuesGrantAccess(obj)
}

function recordValuesGrantAccess(record: Record<string, unknown>): boolean {
	for (const v of Object.values(record)) {
		if (isPermissionGrantActive(v)) {
			return true
		}
	}
	return false
}
